import { makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input, Loading } from '../../root/components/common'
import { getLastTriggeredReports } from '../api/device-api'
import { TriggeredReportSelectList } from './triggered-report-select-list'
import * as actions from '../actions'
import { getSagasMsgs } from '../../root/selectors'
import { enqueueSnackbar } from '../../root/actions'
import { getInitialFiltersState } from '../../root/hooks/useReportsFilters'
import { UserPermissions } from '../../../services/permissions'

export const ReportCatchModal = ({
    contextPage,
    onClose,
    deviceId,
    createdAt
}) => {
    const { locale } = useSelector(state => state.main)
    const sagasMsgs = useSelector(getSagasMsgs)
    const dispatch = useDispatch()
    const [catchDescription, setCatchDescription] = useState('')
    const [selectedReport, setSelectedReport] = useState('')
    const styles = useStyles()

    const isDevicePage = contextPage === 'device'
    const isReportPage = contextPage === 'report'

    const { data, isLoading: isLoadingLastReports } = useQuery(
        ['lastTriggeredReports', deviceId],
        () => getLastTriggeredReports(deviceId),
        {
            enabled: isDevicePage,
            cacheTime: 0,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.commonLoadingError,
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )

    const handleSubmit = () => {
        const created_at = isDevicePage
            ? selectedReport
                ? data.find(i => i.id === selectedReport).created_at
                : undefined
            : createdAt

        dispatch(
            actions.reportCatchRequest(
                deviceId,
                catchDescription,
                created_at,
                getInitialFiltersState(UserPermissions.isAllOriginalGranted())
            )
        )

        onClose()
    }
    if (isDevicePage && isLoadingLastReports) {
        return <Loading />
    }

    return (
        <div className={styles.modalInnerWrapper}>
            {selectedReport
                ? locale.devices.reportCatchSelectReport
                : locale.devices.reportCatchDescr}
            <TriggeredReportSelectList
                reports={data}
                onSelect={setSelectedReport}
                selectedReport={selectedReport}
            />
            <div className={styles.catchDescriptionArea}>
                <div className={styles.catchDescriptionText}>
                    {locale.devices.catchDescriptionMessage}:
                </div>
                <Input
                    label={locale.devices.catchDescription}
                    type="text"
                    setValue={setCatchDescription}
                    value={catchDescription}
                    onEnter={handleSubmit}
                />
            </div>
            <div className={styles.modalButtons}>
                <Button className={styles.actionButton} onClick={handleSubmit}>
                    {locale.devices.reportCatch}
                </Button>
                <Button reverted onClick={onClose}>
                    {locale.common.cancel}
                </Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    modalInnerWrapper: {},
    catchDescriptionArea: {
        marginTop: 8,
        marginBottom: 8
    },
    catchDescriptionText: {
        marginBottom: 8
    },
    actionButton: {
        marginRight: 8
    },
    modalButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    }
}))
